import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Checkbox, Space, Select } from 'antd';
import { apiCall } from "../../utilities/Api";
import PostalCodeFormatter from "../../formatters/PostalCodeFormatter";
import PhoneNumberFormatter from "../../formatters/PhoneNumberFormatter";
import { PROVINCE_STATE_MAP } from "../../../util/Utils";
export default function AddressForm(props) {

    const { data = {}, fetchShippingOptions = () => { }, disable_email_address = false, duel_name = false } = props;
    const {
        name = "",
        address_id = 0,
        company_name = "",
        preferred = false,
        phone_number = "",
        phone_number_ext = "",
        email_address = "",
        street_address = "",
        street_address_2 = "",
        postal_code = "",
        country = "",
        province = "",
        city = "",

    } = data;





    const formValues = Form.useWatch([], props.form);

    const lastValid = useRef(false);
    const lastShippingValues = useRef({});
    const validationId = useRef(0);


    const normalizeProvince = (_value) => {

        if (!_value) {
            return _value;
        }

        const value = _value.trim();

        const key = Object.keys(PROVINCE_STATE_MAP).find(
            item => item.toLowerCase() === value.toLowerCase()
        );

        return key ? PROVINCE_STATE_MAP[key] : value;
    };

    const resolveProvince = (_value) => {

        const normalized = normalizeProvince(_value);

        return provinces.find(
            item => item.toLowerCase() === normalized.toLowerCase()
        ) || "";
    };

    useEffect(() => {
        if (!formValues) return;

        const id = ++validationId.current;

        const checkForm = async () => {
            let valid = false;

            try {
                await props.form.validateFields();
                valid = true;
            } catch {
                valid = false;
            }

            if (id !== validationId.current) return;

            const shippingValues = {
                postal_code: formValues.postal_code,
                country: formValues.country,
                province: formValues.province,
            };

            const shippingChanged =
                lastShippingValues.current.postal_code !== shippingValues.postal_code ||
                lastShippingValues.current.country !== shippingValues.country ||
                lastShippingValues.current.province !== shippingValues.province;

            const validityChanged = lastValid.current !== valid;

            if (validityChanged || shippingChanged) {
                fetchShippingOptions(valid);
            }

            lastValid.current = valid;
            lastShippingValues.current = shippingValues;
        };

        checkForm();

    }, [formValues]);

    const writeToForm = () => {

        if (Object.keys(data).length === 0) {
            props.form.resetFields();
        } else {

            if (duel_name) {
                // split the name on a comma
                const [last_name = "", first_name = ""] = (data.name || "").split(",").map(item => item.trim());
                props.form.setFieldsValue({
                    ...data,
                    name: first_name,
                    last_name: last_name
                });
            } else {
                props.form.setFieldsValue(data);
            }


        }

    }
    useEffect(writeToForm, [props.selectedAddress])

    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(country);
    const [selectedProvince, setSelectedProvince] = useState(province);
    const [provinces, setProvinces] = useState([])

    const onListCountries = (_status, _result) => {
        if (_status) {
            setCountries(_result);
        }
    }

    const listCountries = () => {
        apiCall("country/getList", {}, onListCountries)
    }

    useEffect(listCountries, [])

    const onListProvinces = (_status, _result) => {
        if (_status) {
            setProvinces(_result);
        }
    }

    const listProvinces = (_country) => {
        if (!_country) {
            _country = selectedCountry;
        }
        apiCall("province/getList", { "country": _country }, onListProvinces)
    }

    useEffect(listProvinces, [selectedCountry])

    const formatMessage = () => {

        if (selectedCountry === "Canada") {

        }

        if (selectedCountry === "Canada") {

        }

        return;

    }

    const postalError = () => {
        let ret = "Valid postal code is required.";
        if (selectedCountry === "Canada") {
            return ret + " eg. A1B 2C3"
        }

        if (selectedCountry === "United States") {
            return ret + " eg. 12345 or 12345-6789"
        }

        return ret;
    }

    return (<>
        <Form.Item initialValue={address_id} name="address_id" noStyle >
            <Input type="hidden" />
        </Form.Item>

        {(!duel_name &&
            <Form.Item initialValue={name} label="Full Name" name="name" rules={[{ message: "Full Name is required.", required: true }]}>
                <Input size="large" />
            </Form.Item>

        )}

        {(duel_name &&
            <Space>
                <Form.Item initialValue={name} label="First Name" name="name" rules={[{ message: "First Name is required.", required: true }]}>
                    <Input  onKeyDown={e => { if (e.key === ",") { e.preventDefault(); } }} size="large" />
                </Form.Item>
                <Form.Item initialValue={name} label="Last Name" name="last_name" rules={[{ message: "Last Name is required.", required: true }]}>
                    <Input onKeyDown={e => { if (e.key === ",") { e.preventDefault(); } }} size="large" />
                </Form.Item>
            </Space>
        )}


        <Form.Item initialValue={company_name} label={<>Company / Institution&nbsp;<em> (optional)</em></>} name="company_name">
            <Input size="large" />
        </Form.Item>

        <Form.Item rules={[{ required: true }]} label={<><span style={{ color: "#ff4d4f", fontSize: "14px", fontFamily: "SimSun, sans-serif" }}>*</span>&nbsp;Phone Number</>}>
            <Input.Group compact>
                <Form.Item noStyle initialValue={phone_number} label="Phone Number" name="phone_number" rules={[{ pattern: /^[0-9+. \-)(]{10,15}$/, required: true, min: 10, message: "Phone number is required." }]} >
                    <PhoneNumberFormatter style={{ width: "156px" }} country={selectedCountry} />
                </Form.Item>

                <Form.Item noStyle initialValue={phone_number_ext} name="phone_number_ext" rules={[{ message: "Must be between 2 and 6 digits", pattern: new RegExp(/^[0-9]{2,6}$/g), required: false }]}>
                    <Input field="phone_number_ext" style={{ width: '80px' }} size="large" maxLength={6} inputMode="numeric" placeholder="Ext." />
                </Form.Item>
            </Input.Group>
        </Form.Item>

        <Form.Item initialValue={email_address} label="Email Address" type="email" name="email_address" rules={[{ message: "Email address is required." }]}>
            <Input disabled={disable_email_address} size="large" inputMode="email" type="email" />
        </Form.Item>

        <Form.Item initialValue={street_address} label="Street Address" name="street_address" rules={[{ message: "Street Address is required.", required: true }]}>
            <Input size="large" />
        </Form.Item>

        <Form.Item initialValue={street_address_2} label="Street Address (line 2)" name="street_address_2" rules={[{ required: false }]}>
            <Input size="large" />
        </Form.Item>

        <Form.Item initialValue={city} label="City" name="city" rules={[{ message: "City is required.", required: true }]}>
            <Input size="large" />
        </Form.Item>

        <Form.Item initialValue={country} label="Country" name="country" rules={[{ validateTrigger: "onBlur", validator: (_, value) => (countries.includes(value)) ? Promise.resolve() : Promise.reject("no"), message: "Valid country is required.", required: true }]}>

            <Select size="large" showSearch placeholder="Country" style={{ maxWidth: 400 }} onChange={(v) => setSelectedCountry(v)}>
                {countries.map((item, index) => {
                    return (<Select.Option key={index} value={item}>{item}</Select.Option>)
                })}
            </Select>

        </Form.Item>

        {(
            province !== false &&
            provinces.length > 0 &&
            selectedCountry
        ) && (
                <>
                    <input
                        name="address-level1"
                        autoComplete="address-level1"
                        tabIndex={-1}
                        style={{
                            position: "absolute",
                            opacity: 0,
                            pointerEvents: "none",
                            width: 1,
                            height: 1
                        }}
                        onInput={(e) => {

                            const value = resolveProvince(e.target.value);

                            if (value) {
                                props.form.setFieldsValue({
                                    province: value
                                });

                                setSelectedProvince(value);
                            }
                        }}
                    />

                    <Form.Item
                        initialValue={province}
                        label="State / Province"
                        name="province"
                        rules={[
                            {
                                validateTrigger: "onBlur",
                                validator: (_, value) =>
                                    provinces.includes(value)
                                        ? Promise.resolve()
                                        : provinces.length > 0
                                            ? Promise.reject("no")
                                            : Promise.resolve(),
                                message: "Valid state / province is required.",
                                required: true
                            }
                        ]}
                    >
                        <Select
                            size="large"
                            showSearch
                            placeholder="State / Province"
                            onChange={(v) => setSelectedProvince(v)}
                            style={{ maxWidth: 400 }}
                        >
                            {provinces.map((item, index) => (
                                <Select.Option
                                    key={index}
                                    value={item}
                                >
                                    {item}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </>
            )}

        {(province !== false && (!provinces.length > 0) && (selectedCountry) && <Form.Item initialValue={province} label="State / Province" name="province" rules={[{ validateTrigger: "onBlur", validator: (_, value) => (provinces.includes(value)) ? Promise.resolve() : (provinces.length > 0) ? Promise.reject("no") : Promise.resolve(), message: "Valid state / province is required.", required: false }]}>
            <Input autoComplete="address-level1" size="large" style={{ maxWidth: 400 }} maxLength={80} />
        </Form.Item>)}



        <Form.Item initialValue={postal_code} label={selectedCountry === "United States" ? "Zip Code" : "Postal Code"} name="postal_code" rules={[{ pattern: selectedCountry === "Canada" ? /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/ : selectedCountry === "United States" ? /(^\d{5}$)|(^\d{5}-\d{4}$)/ : "", message: postalError(), required: true }]} >
            <PostalCodeFormatter size="large" country={selectedCountry} />
        </Form.Item>

        <Space>

            {(props.type === "shipping" && <>
                <Form.Item initialValue={true} name="preferred" noStyle >
                    <Input type="hidden" />
                </Form.Item>
            </>)}

            {(!props.type && <>

                <Form.Item noStyle name="preferred" initialValue={preferred} valuePropName="checked">
                    <Checkbox>Default Shipping Address</Checkbox>
                </Form.Item></>)}

        </Space>

    </>);

}